import React from "react";
import type { Step, ShowWhen, HubSpotProduct } from "../../types/configurator";
import { TrashIcon } from "../ui/Icons";

interface Props {
  condition: ShowWhen;
  condStep: Step;
  condStepIndex: number;
  productMap: Record<string, HubSpotProduct>;
  onUpdate: (selectedAny: string[]) => void;
  onRemove: () => void;
}

export const ConditionRow: React.FC<Props> = ({
  condition,
  condStep,
  condStepIndex,
  productMap,
  onUpdate,
  onRemove,
}) => {
  const toggle = (value: string) => {
    const next = condition.selectedAny.includes(value)
      ? condition.selectedAny.filter((v) => v !== value)
      : [...condition.selectedAny, value];
    onUpdate(next);
  };

  return (
    <div className="condition-row">
      <div className="condition-row-header">
        <span className="condition-step-label">
          Step {condStepIndex + 1}: {condStep.title || `Step ${condStepIndex + 1}`}
        </span>
        <button className="remove-condition" onClick={onRemove} title="Remove condition">
          <TrashIcon />
        </button>
      </div>
      <div className="condition-row-body">
        <span className="condition-hint">Show only if any of:</span>
        <div className="condition-values">
          {condStep.items.map((item) => {
            const value = item.type === 'product' ? item.productId : item.value;
            const label = item.type === 'product'
              ? (productMap[item.productId]?.name ?? null)
              : item.label;
            if (!label) return null;
            const checked = condition.selectedAny.includes(value);
            return (
              <label key={item.uid} className="condition-value-label">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggle(value)}
                />
                {label}
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};
